import {GESTION_OPERATIVA_EDIT_DELIVERY_COSTS} from "../constants"

export function reducer(state, action) {
    if(action.type===GESTION_OPERATIVA_EDIT_DELIVERY_COSTS){
        return {
            ...state,
            delivery_costs_manually_edited: true,
            sale: {
                ...state.sale,
                delivery_costs: action.data,
                delivery_costs_original: state.sale.delivery_costs_original ?? state.sale.delivery_costs
            },
            isModified: true
          }
    }else{
        return state
    }
  }